import { Box, Typography, Container, BoxProps } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { PolicyDisclaimers } from './policy-disclaimer';

const useStyles = makeStyles()(theme => ({
  footer: {
    width: '100%',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0)
    }
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    }
  },
  contentContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  hotline: {
    fontSize: '14px',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}));

export const OnboardingContainer = withStyles(Container, theme => ({
  maxWidthLg: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1400px',
    },
  },
}));

export const CrisisHotlineFooter: React.VFC<BoxProps> = props => {
  const { classes } = useStyles();
  const l10n = useL10n();

  return (
    <Box
      className={classes.footer}
      {...props}
    >
      <OnboardingContainer>
        <Box className={classes.container}>
          <Box className={classes.contentContainer}>
            <PolicyDisclaimers />
          </Box>
          <Box color="text.secondary">
            <Typography className={classes.hotline}>
              {l10n.matching.providers.hotline}
            </Typography>
          </Box>
        </Box>
      </OnboardingContainer>
    </Box>
  );
};
